module.exports = __webpack_public_path__ + "static/media/index_background.d3a7b2ff.jpg";